import { useEffect, useRef } from "react";

function useCurrentRefValue<T>(value: T): T | undefined {
  const ref = useRef<T | undefined>();

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
}

export default useCurrentRefValue;
